import React from 'react';
import '../css/services.css';
import FadeInSection from '../components/FadeInSection';

const SERVICES = [
  { icon: '🎨', title: 'Branding & Identity', items: ['Logo Design', 'Brand Guidelines', 'Visual Identity Development', 'Packaging Design', 'Brand Positioning'] },
  { icon: '📱', title: 'Digital Marketing', items: ['Social Media Management', 'Social Media Advertising', 'Content Creation', 'Campaign Management', 'Influencer Marketing'] },
  { icon: '💻', title: 'Website & Digital', items: ['Website Design & Development', 'Landing Pages', 'UI/UX Design', 'SEO Optimization', 'Digital Consultation'] },
  { icon: '🎬', title: 'Media Production', items: ['Photography', 'Videography', 'Drone Filming', 'Promotional Videos', 'Documentary Production'] },
  { icon: '🎪', title: 'Event Management', items: ['Corporate Events & Conferences', 'Product Launches', 'Festivals & Public Events', 'Weddings & Private Events', 'Stage & Venue Design'] },
  { icon: '🖼️', title: 'Graphic Design', items: ['Promotional Designs', 'Brochures & Flyers', 'Billboard & Outdoor Ads', 'Event Branding', 'Corporate Profiles'] },
];

export default function Services() {
  return (
    <div className="services-page">
      <FadeInSection direction="up">
      <section className="services-hero">
        <div className="container">
          <span className="section-tag">What We Do</span>
          <h1>Our Services</h1>
          <p className="section-sub">Everything your brand needs — under one roof.</p>
        </div>
      </section>
      </FadeInSection>

      <FadeInSection direction="right">
      <section className="section section-white">
        <div className="container">
          <div className="services-grid-full">
            {SERVICES.map(s => (
              <div key={s.title} className="service-card-full">
                <div className="service-icon-lg">{s.icon}</div>
                <h3>{s.title}</h3>
                <ul>{s.items.map(i => <li key={i}><span>—</span>{i}</li>)}</ul>
              </div>
            ))}
          </div>
        </div>
      </section>
      </FadeInSection>
    </div>
  );
}
